<template>
  <Toast />
  <ConfirmDialog></ConfirmDialog>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Restaurante</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Gestión de Mesas</span>
    </li>
  </ul>

  <div class="surface-section px-4 py-4 md:px-6 lg:px-8">
    <div class="flex justify-content-between align-items-center mb-3">
      <div>
        <h3 class="text-900 font-bold m-0 mb-1" style="font-size: 1.3rem">
          Administración de Mesas
        </h3>
        <p class="text-600 m-0" style="font-size: 0.9rem">
          Gestione las mesas del restaurante
        </p>
      </div>
      <div class="flex gap-2">
        <Button
          label="Ver Plano"
          icon="pi pi-th-large"
          class="p-button-success p-button-sm"
          @click="$router.push({ name: 'restaurante_plano_mesas' })"
        />
        <Button
          label="Nueva Mesa"
          icon="pi pi-plus"
          class="p-button-info p-button-sm"
          @click="abrirDialogNuevo"
          v-if="'Mesa Crear' in permisos"
        />
      </div>
    </div>

    <div class="surface-card p-2 mb-3 border-round">
      <div class="grid">
        <div class="col-12 md:col-3">
          <InputText
            v-model="filtros.buscar"
            placeholder="Buscar mesa..."
            class="w-full p-inputtext-sm"
            @input="cargarMesas"
          />
        </div>
        <div class="col-12 md:col-3">
          <Dropdown
            v-model="filtros.sucursal_id"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
            placeholder="Todas las sucursales"
            class="w-full"
            showClear
            @change="cargarMesas"
            :pt="{ root: { class: 'p-inputtext-sm' } }"
          >
            <template #value="slotProps">
              <span v-if="slotProps.value" style="font-size: 0.9rem">
                {{ getSucursalNombre(slotProps.value) }}
              </span>
              <span v-else class="text-500" style="font-size: 0.9rem">
                Todas las sucursales
              </span>
            </template>
          </Dropdown>
        </div>
        <div class="col-12 md:col-2">
          <Dropdown
            v-model="filtros.zona"
            :options="zonas"
            placeholder="Todas las zonas"
            class="w-full"
            showClear
            @change="cargarMesas"
            :pt="{ root: { class: 'p-inputtext-sm' } }"
          />
        </div>
        <div class="col-12 md:col-2">
          <Dropdown
            v-model="filtros.estado"
            :options="estadosFiltro"
            optionLabel="label"
            optionValue="value"
            placeholder="Todos los estados"
            class="w-full"
            showClear
            @change="cargarMesas"
            :pt="{ root: { class: 'p-inputtext-sm' } }"
          />
        </div>
        <div class="col-12 md:col-2">
          <Dropdown
            v-model="filtros.per_page"
            :options="[25, 50, 100]"
            class="w-full"
            @change="cargarMesas"
            :pt="{ root: { class: 'p-inputtext-sm' } }"
          />
        </div>
      </div>
    </div>

    <div class="grid mb-3">
      <div class="col-6 md:col-3">
        <div class="stat-card">
          <div class="stat-value">{{ paginacion.total }}</div>
          <div class="stat-label">Total Mesas</div>
        </div>
      </div>
      <div class="col-6 md:col-3">
        <div class="stat-card stat-success">
          <div class="stat-value">{{ estadisticas.disponibles }}</div>
          <div class="stat-label">Disponibles</div>
        </div>
      </div>
      <div class="col-6 md:col-3">
        <div class="stat-card stat-danger">
          <div class="stat-value">{{ estadisticas.ocupadas }}</div>
          <div class="stat-label">Ocupadas</div>
        </div>
      </div>
      <div class="col-6 md:col-3">
        <div class="stat-card stat-warning">
          <div class="stat-value">{{ estadisticas.reservadas }}</div>
          <div class="stat-label">Reservadas</div>
        </div>
      </div>
    </div>

    <div class="surface-card border-round">
      <DataTable
        :value="mesas"
        :loading="cargando"
        class="p-datatable-sm tabla-compacta"
        showGridlines
        stripedRows
      >
        <Column header="#">
          <template #body="{ index }">
            <span class="font-bold">
              {{
                (paginacion.current_page - 1) * paginacion.per_page + index + 1
              }}
            </span>
          </template>
        </Column>

        <Column field="numero" header="MESA">
          <template #body="{ data }">
            <div class="font-bold text-900" style="font-size: 0.95rem">
              Mesa {{ data.numero }}
            </div>
            <div class="text-xs text-600">{{ data.capacidad }} personas</div>
          </template>
        </Column>

        <Column field="zona" header="ZONA">
          <template #body="{ data }">
            <span style="font-size: 0.9rem">{{ data.zona || "—" }}</span>
          </template>
        </Column>

        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <Tag
              :value="getEstadoLabel(data.estado)"
              :severity="getEstadoSeverity(data.estado)"
              style="font-size: 0.75rem; padding: 0.25rem 0.5rem"
            />
          </template>
        </Column>

        <Column header="PEDIDO">
          <template #body="{ data }">
            <div v-if="data.pedido_id">
              <div class="font-bold" style="font-size: 0.9rem">
                #{{ data.pedido_id }}
              </div>
              <div class="text-xs text-info font-bold">
                Bs. {{ formatCurrency(data.pedido_total) }}
              </div>
              <div class="text-xs text-500">{{ data.tiempo_ocupada }}</div>
            </div>
            <span v-else class="text-400">—</span>
          </template>
        </Column>

        <Column field="sucursal_nombre" header="SUCURSAL">
          <template #body="{ data }">
            <span style="font-size: 0.9rem">{{ data.sucursal_nombre }}</span>
          </template>
        </Column>

        <Column header="ACCIONES">
          <template #body="{ data }">
            <div class="flex gap-1 flex-wrap">
              <Button
                icon="pi pi-pencil"
                class="p-button-text p-button-sm"
                v-tooltip.top="'Editar'"
                @click="editarMesa(data)"
                v-if="'Mesa Editar' in permisos"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-text p-button-danger p-button-sm"
                v-tooltip.top="'Eliminar'"
                @click="confirmarEliminar(data)"
                v-if="'Mesa Eliminar' in permisos"
              />

              <Button
                v-else-if="data.estado === 2"
                label="Ver"
                icon="pi pi-eye"
                class="p-button-info p-button-sm"
                @click="verPedido(data)"
              />
            </div>
          </template>
        </Column>
      </DataTable>

      <div class="p-2" v-if="mesas.length > 0">
        <div class="flex justify-content-between align-items-center">
          <span class="text-600" style="font-size: 0.85rem">
            Mostrando {{ paginacion.from }} - {{ paginacion.to }} de
            {{ paginacion.total }}
          </span>
          <Paginator
            :rows="paginacion.per_page"
            :totalRecords="paginacion.total"
            :first="(paginacion.current_page - 1) * paginacion.per_page"
            @page="onPageChange"
            :pt="{ root: { class: 'p-paginator-sm' } }"
          />
        </div>
      </div>
    </div>
  </div>

  <Dialog
    v-model:visible="dialogMesa"
    :style="{ width: '600px' }"
    :header="modoEdicion ? 'Mesa Detalle (Editar)' : 'Mesa Detalle (Nueva)'"
    :modal="true"
    class="p-fluid"
    @hide="cerrarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-6">
          <span
            ><strong>NÚMERO DE MESA: </strong
            ><span class="p-invalid">*</span></span
          >
          <InputText
            v-model.trim="mesa.numero"
            v-uppercase
            placeholder="Ej: MESA 01"
            autofocus
            :class="{ 'p-invalid': submitted && !mesa.numero }"
          />
          <small class="p-invalid" v-if="submitted && !mesa.numero"
            >El número es requerido.</small
          >
        </div>

        <div class="field col-12 md:col-6">
          <span
            ><strong>CAPACIDAD: </strong><span class="p-invalid">*</span></span
          >
          <InputNumber
            v-model="mesa.capacidad"
            :min="1"
            :max="20"
            showButtons
            :class="{ 'p-invalid': submitted && !mesa.capacidad }"
          />
        </div>

        <div class="field col-12 md:col-6">
          <span><strong>ZONA / AMBIENTE: </strong></span>
          <Dropdown
            v-model="mesa.zona"
            :options="zonas"
            placeholder="Seleccione o escriba zona..."
            editable
          />
        </div>

        <div class="field col-12 md:col-6">
          <span
            ><strong>SUCURSAL: </strong><span class="p-invalid">*</span></span
          >
          <Dropdown
            v-model="mesa.sucursal_id"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
            placeholder="Seleccione sucursal..."
            :class="{ 'p-invalid': submitted && !mesa.sucursal_id }"
          />
          <small class="p-invalid" v-if="submitted && !mesa.sucursal_id">
            Debe asignar una sucursal.
          </small>
        </div>

        <div class="field col-12 md:col-6" v-if="modoEdicion">
          <span><strong>ESTADO: </strong></span>
          <Dropdown
            v-model="mesa.estado"
            :options="estadosMesa"
            optionLabel="label"
            optionValue="value"
          >
            <template #value="slotProps">
              <span
                v-if="slotProps.value !== null"
                :class="'product-badge ' + claseEstado[slotProps.value]"
              >
                {{
                  estadosMesa.find((e) => e.value === slotProps.value)?.label
                }}
              </span>
            </template>
          </Dropdown>
        </div>

        <div class="field col-12 md:col-6 flex align-items-center mt-3">
          <Checkbox
            v-model="mesa.activo"
            :binary="true"
            inputId="activo_mesa"
          />
          <label for="activo_mesa" class="ml-2"
            ><strong>MESA ACTIVA</strong></label
          >
        </div>
      </div>
    </div>

    <template #footer>
      <div class="field">
        <span class="flex md:justify-content-start"
          ><strong>CAMPOS REQUERIDOS: </strong
          ><span class="p-invalid">*</span></span
        >
      </div>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="cerrarDialog"
      />
      <Button
        :label="modoEdicion ? 'ACTUALIZAR' : 'GUARDAR'"
        :icon="modoEdicion ? 'pi pi-pencil' : 'pi pi-save'"
        class="p-button-info p-button-lg"
        @click="guardarMesa"
        :loading="guardando"
      />
    </template>
  </Dialog>
</template>

<script>
import RestauranteService from "@/service/RestauranteService";
import SucursalService from "@/service/SucursalService";
import { useAuth } from "@/stores";

export default {
  data() {
    return {
      mesas: [],
      sucursales: [],
      zonas: ["PRINCIPAL", "INTERIOR", "EXTERIOR", "GARAGE", "OTROS"],
      claseEstado: {
        1: "status-instock",
        2: "status-outofstock",
        3: "status-lowstock",
      },
      estadosFiltro: [
        { label: "Disponible", value: 1 },
        { label: "Ocupada", value: 2 },
        { label: "Reservada", value: 3 },
      ],
      estadosMesa: [
        { label: "Disponible", value: 1 },
        { label: "Ocupada", value: 2 },
        { label: "Reservada", value: 3 },
      ],
      filtros: {
        buscar: "",
        sucursal_id: null,
        zona: null,
        estado: null,
        per_page: 25,
        page: 1,
      },
      paginacion: {
        current_page: 1,
        last_page: 1,
        per_page: 25,
        total: 0,
        from: 0,
        to: 0,
      },
      estadisticas: { disponibles: 0, ocupadas: 0, reservadas: 0 },
      dialogMesa: false,
      mesa: {},
      auth: null,
      modoEdicion: false,
      submitted: false,
      cargando: false,
      guardando: false,
      permisos: {},
    };
  },
  created() {
    this.restauranteService = new RestauranteService();
    this.sucursalService = new SucursalService();
    this.auth = useAuth();
    this.permisos = this.auth.user.permissions;
    // Pre-asignar la sucursal del usuario a los filtros
    this.filtros.sucursal_id = this.auth.user.sucursal_id;
  },
  mounted() {
    this.cargarSucursales();
    this.cargarMesas();
  },
  methods: {
    async cargarSucursales() {
      try {
        const response = await this.sucursalService.getSucursalesAll();
        this.sucursales = response.sucursales || response || [];

        if (this.sucursales.length > 0) {
          const primeraSucursalId = this.sucursales[0].id;
          if (!this.filtros.sucursal_id) {
            this.filtros.sucursal_id = primeraSucursalId;
          }
          this.cargarMesas();
        }
      } catch (error) {
        console.error("Error al cargar sucursales:", error);
      }
    },

    abrirDialogNuevo() {
      this.mesa = {
        numero: "",
        capacidad: 4,
        estado: 1,
        zona: "Salón Principal",
        sucursal_id: this.sucursales.length > 0 ? this.sucursales[0].id : null,
        activo: true,
      };
      this.modoEdicion = false;
      this.submitted = false;
      this.dialogMesa = true;
    },

    editarMesa(data) {
      this.mesa = { ...data };
      this.mesa.activo = data.activo === 1;
      this.modoEdicion = true;
      this.submitted = false;
      this.dialogMesa = true;
    },

    async cargarMesas() {
      try {
        this.cargando = true;
        const response = await this.restauranteService.getMesas(this.filtros);
        if (response.status === 200) {
          this.mesas = response.data || [];
          this.paginacion = {
            current_page: response.current_page,
            last_page: response.last_page,
            total: response.total,
            from: response.from,
            to: response.to,
            per_page: parseInt(response.per_page),
          };
          this.calcularEstadisticas();
        }
      } finally {
        this.cargando = false;
      }
    },

    confirmarEliminar(data) {
      if (data.estado === 2) {
        this.$toast.add({
          severity: "warn",
          summary: "No se puede eliminar",
          detail: `La mesa ${data.numero} está ocupada`,
          life: 3000,
        });
        return;
      }

      if (data.pedido_id) {
        this.$toast.add({
          severity: "warn",
          summary: "No se puede eliminar",
          detail: `La mesa ${data.numero} tiene un pedido activo`,
          life: 3000,
        });
        return;
      }

      this.$confirm.require({
        message: `¿Está seguro de eliminar la mesa ${data.numero}?`,
        header: "Confirmar Eliminación",
        icon: "pi pi-exclamation-triangle",
        acceptClass: "p-button-danger",
        acceptLabel: "Sí, eliminar",
        rejectLabel: "Cancelar",
        accept: () => this.eliminarMesa(data.id),
      });
    },

    async eliminarMesa(id) {
      try {
        const response = await this.restauranteService.eliminarMesa(id);
        if (response.status === 200) {
          this.$toast.add({
            severity: "success",
            summary: "Mesa eliminada",
            detail: "La mesa fue eliminada correctamente",
            life: 2000,
          });
          this.cargarMesas();
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error al eliminar",
          detail:
            error.response?.data?.mensaje || "No se pudo eliminar la mesa",
          life: 3000,
        });
      }
    },

    async guardarMesa() {
      this.submitted = true;
      if (!this.mesa.numero || !this.mesa.capacidad || !this.mesa.sucursal_id) {
        return;
      }

      try {
        this.guardando = true;
        const datos = {
          ...this.mesa,
          activo: this.mesa.activo ? 1 : 0,
        };

        let response;
        if (this.modoEdicion) {
          response = await this.restauranteService.actualizarMesa(
            this.mesa.id,
            datos,
          );
        } else {
          response = await this.restauranteService.crearMesa(datos);
        }

        if (response.status === 200) {
          this.$toast.add({
            severity: "success",
            summary: this.modoEdicion ? "Mesa actualizada" : "Mesa creada",
            life: 2000,
          });
          this.cerrarDialog();
          this.cargarMesas();
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error al guardar",
          detail: error.response?.data?.mensaje || "Ocurrió un error",
          life: 3000,
        });
      } finally {
        this.guardando = false;
      }
    },
    verPedido(mesa) {
      if (mesa.pedido_id) {
        this.$router.push({
          name: "restaurante_tomar_pedido",
          params: { pedido_id: mesa.pedido_id },
        });
      }
    },

    onPageChange(event) {
      this.filtros.page = event.page + 1;
      this.cargarMesas();
    },

    calcularEstadisticas() {
      this.estadisticas = {
        disponibles: this.mesas.filter((m) => m.estado === 1).length,
        ocupadas: this.mesas.filter((m) => m.estado === 2).length,
        reservadas: this.mesas.filter((m) => m.estado === 3).length,
      };
    },

    getSucursalNombre(id) {
      return this.sucursales.find((s) => s.id === id)?.nombre || "";
    },

    getEstadoLabel(e) {
      return this.estadosMesa.find((i) => i.value === e)?.label || "—";
    },

    getEstadoSeverity(e) {
      return { 1: "success", 2: "danger", 3: "warning" }[e] || "info";
    },

    formatCurrency(v) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(v || 0);
    },

    cerrarDialog() {
      this.dialogMesa = false;
      this.mesa = {};
      this.submitted = false;
    },
  },
};
</script>

<style scoped lang="scss">
/* Estilos unificados con badges.scss */
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: #ef4444;
}
strong {
  font-size: 0.85rem;
  color: #4b5563;
}

.stat-card {
  background: white;
  padding: 0.75rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border-left: 3px solid #e5e7eb;
}
.stat-success {
  border-left-color: #10b981;
}
.stat-danger {
  border-left-color: #ef4444;
}
.stat-warning {
  border-left-color: #f59e0b;
}
.stat-value {
  font-size: 1.75rem;
  font-weight: 700;
}
</style>
